import { useLocation } from 'react-router-dom';

// Standalone pages (property listing sites) render without the RC Studios nav, footer and book bar.
const BARE_PREFIXES = ['/listing/'];

export const SiteChrome = ({ children }) => {
  const { pathname } = useLocation();
  return BARE_PREFIXES.some((p) => pathname.startsWith(p)) ? null : children;
};
